export default __webpack_public_path__ + "static/media/two.4c78792f.jpeg";